<template>

    <nav class="list-view-nav">
        <slot></slot>
    </nav>

</template>

<style lang="scss">
    nav.list-view-nav{
        background-color: #FFF;
        border-radius: $standardBorderRadius;
        padding: 1em;

        @include grid-column(12);

        @include mobile(){
            border-radius:0;
            width: 100%;
            margin-left: 0;
        }
    }
</style>

<script>
    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {}
    }
</script>   
